import type { SubScores } from "@talent-align/engine";

interface Props {
  subScores: SubScores;
}

const LABELS: Array<{ key: keyof SubScores; label: string; desc: string }> = [
  { key: "semantic", label: "Semantic", desc: "Overall meaning overlap" },
  { key: "keyword", label: "Keywords", desc: "TF-IDF + BM25 term match" },
  { key: "bullet", label: "Bullets", desc: "Per-experience alignment" },
  { key: "section", label: "Sections", desc: "Structured section overlap" },
  { key: "title", label: "Title", desc: "Job family match" },
  { key: "seniority", label: "Seniority", desc: "Years-of-experience band" },
  { key: "field", label: "Field", desc: "Domain + cross-domain fit" },
];

function barColor(v: number): string {
  if (v >= 0.8) return "from-emerald-500 to-teal-400";
  if (v >= 0.55) return "from-amber-500 to-yellow-400";
  return "from-rose-500 to-pink-400";
}

export function SubScoreBars({ subScores }: Props) {
  return (
    <div className="ta-card p-6">
      <h3 className="text-sm uppercase tracking-wider text-slate-500 font-semibold mb-4">
        Seven-signal breakdown
      </h3>
      <div className="space-y-4">
        {LABELS.map(({ key, label, desc }) => {
          const value = subScores[key];
          return (
            <div key={key}>
              <div className="flex items-baseline justify-between mb-1.5">
                <div>
                  <span className="text-sm font-medium text-slate-200">
                    {label}
                  </span>
                  <span className="text-xs text-slate-500 ml-2">{desc}</span>
                </div>
                <span className="text-sm font-mono text-slate-300">
                  {(value * 100).toFixed(0)}
                </span>
              </div>
              <div className="h-2 rounded-full bg-slate-800/70 overflow-hidden">
                <div
                  className={`h-full rounded-full bg-gradient-to-r ${barColor(value)} transition-all duration-500`}
                  style={{ width: `${Math.max(2, value * 100)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
